import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Helmet } from "react-helmet";
import keycloak from "./auth/keycloak";
import { routes } from './routes';
import React from 'react';
import { PrivateLayout } from './layout';
import { Route, Routes, useNavigate } from 'react-router-dom';
import Error404 from './components/Errors/Error404';
import { ReactKeycloakProvider } from '@react-keycloak/web';
import { updateAbility } from './security/updateAbility';
import ability from './security/ability';
import { selectCurrentUser, setAuthUser, setAuthentificated, setKeycloakIsLoading, setToken } from './auth/AuthUserSlice';
import ProtectedRoute from './utils/ProtectedRoute';
import { clients } from './lib/axios';


  // Check if the structure of this user already exist
  export const CheckIfExist = async (emailHasUsername: string) => {
    const axios = await clients();
    let response = await axios({ url: `/api/check/${emailHasUsername}`, method: 'GET' });

    console.log("CHECK ", response.data);
    return response.data;
  };

function App() {

  const dispatch = useDispatch();

  const eventLogger = (event: unknown, error: unknown) => {
    if(event == "onAuthSuccess") {
        // console.log("KEYCLOAK ", JSON.stringify(keycloak));
        /**
         * this section is executed when the user is connected
        */
        keycloak.authenticated && updateAbility(ability, keycloak);
        console.log('Authentication SUCCESS');
        dispatch(setKeycloakIsLoading(""));
  
        /**
         * We dispatch the information of authentificated user
        */
        dispatch(setAuthUser(keycloak.tokenParsed??{family_name:""}));
        dispatch(setAuthentificated(keycloak.authenticated??false));
        dispatch(setToken(keycloak.token??""));
  
    }
	if(event == "onTokenExpired") {
		  keycloak.logout();
	}
	if(event == "onAuthRefreshSuccess"){
      /**
       * We improve a soft refresh token
      */
      keycloak.updateToken(keycloak.tokenParsed?.expires_in * 1000).then((isRefreshed) =>{
        if(isRefreshed) console.log("Token succefully refreshed");
        else console.log("Token still valid");
      }).catch((e)=>{
        console.log("Refresh token failed");
      });
       dispatch(setAuthUser(keycloak.tokenParsed ?? { family_name: "" }));
       dispatch(setAuthentificated(keycloak.authenticated ?? false));
       dispatch(setKeycloakIsLoading(""));
	}
 
  }
  
  const tokenLogger = (tokens: unknown) => {
    // console.log('onKeycloakTokens', tokens);
	  // dispatch(setToken(tokens?.token?? ""));
    console.log('onKeycloakTokens');
    dispatch(setKeycloakIsLoading(""));
  }


  useEffect(() => {
    document.title = "Fondation Orange Cameroun";

    /**
     * This methode initiate the authentification flow when the user is not connected
     */
    /* console.log('init app')
    keycloak.init({
      onLoad: "login-required",
      checkLoginIframe: false,
      scope: "openid"
    })
    .then(() => {
      /**
       * this section is executed when the user is connected
       */

   /*   keycloak.authenticated && updateAbility(ability, keycloak);
      console.log('init authentication')
      console.log(keycloak)
      console.log(routes)
      /**
       * We dispatch the information of authentificated user
       */
    /*  dispatch(setAuthUser(keycloak.tokenParsed??{family_name:""}));
      dispatch(setAuthentificated(keycloak.authenticated??false));
      dispatch(setToken(keycloak.token??""));

      /**
       * We improve a soft refresh token
       */
    /*  keycloak.updateToken(keycloak.tokenParsed?.expires_in * 1000).then((isRefreshed) =>{
        if(isRefreshed) console.log("Token succefuly refreshed");
        else console.log("Token still valid");
      }).catch((e)=>{
        console.log("Refresh token failed");
      });
       
    });*/

  },[]); 


  return (
    <>
      <div className="main-id-container">
      {
        <ReactKeycloakProvider   initOptions={{
          checkLoginIframe: false,
          scope: "openid"
         }} authClient={keycloak} onEvent={eventLogger} onTokens={tokenLogger}>
          <React.StrictMode>
            <PrivateLayout>
              <Routes>
                {routes.map((route) => (
                  <Route path={route.to} element={ 
                    <ProtectedRoute to={route.to}>
                      { route.to !== "*" ? <route.element /> : <Error404 /> }
                    </ProtectedRoute>
                 } key={route.to}></Route>    
                ))}
                {/* <Route path={"*"} element={<Error404 />} ></Route> */}
              </Routes>
            </PrivateLayout>
          </React.StrictMode> 
        </ReactKeycloakProvider>
      }
        
      </div>

    </>
  );
}

export default App;
function dispatch(arg0: any) {
  throw new Error('Function not implemented.');
}

